import http from "@/libs/axios";

// materials
export function getProductCategories(params) {
  return http({
    method: "GET",
    url: "/product/categories/",
    params,
  });
}
export function createProductCategory(payload) {
  return http({
    method: "POST",
    url: "/product/categories/",
    data: payload,
  });
}
export function updateProductCategory(payload) {
  return http({
    method: "PATCH",
    url: `/product/categories/${payload.id}`,
    data: payload.data,
  });
}
export function deleteProductCategory(payload) {
  return http({
    method: "DELETE",
    url: `/product/categories/${payload}`,
  });
}
export function createMaterials(data) {
  return http({
    method: "POST",
    url: "/product/products/",
    data,
  });
}

export function getMaterials(params) {
  return http({
    method: "GET",
    url: "/product/products/",
    params,
  });
}

export function updateMaterials({ data, id }) {
  return http({
    method: "PATCH",
    url: `/product/products/${id}/`,
    data,
  });
}

export function deleteMaterials(id) {
  return http({
    method: "DELETE",
    url: `/product/products/${id}/`,
  });
}

// characterUnits
export function createCharacter(data) {
  return http({
    method: "POST",
    url: "/product/characters/",
    data,
  });
}

export function getCharacter(params) {
  return http({
    method: "GET",
    url: "/product/characters/",
    params,
  });
}

export function deleteCharacter(id) {
  return http({
    method: "DELETE",
    url: `/product/characters/${id}/`,
  });
}

export function updateCharacter({ data, id }) {
  return http({
    method: "PATCH",
    url: `/product/characters/${id}/`,
    data,
  });
}

// units
export function createUnits(data) {
  return http({
    method: "POST",
    url: "/product/unities/",
    data,
  });
}

export function getUnits(params) {
  return http({
    method: "GET",
    url: "/product/unities",
    params,
  });
}

export function deleteUnits(id) {
  return http({
    method: "DELETE",
    url: `/product/unities/${id}/`,
  });
}

export function updateUnits({ data, id }) {
  return http({
    method: "PATCH",
    url: `/product/unities/${id}/`,
    data,
  });
}

// instruments

export function createInstrumentsCategory(data) {
  return http({
    method: "POST",
    url: "/instruments/categories/",
    data,
  });
}

export function getInstrumentsCategory(params) {
  return http({
    method: "GET",
    url: "/instruments/categories/",
    params,
  });
}

export function updateCInstrumentsCategory({ data, id }) {
  return http({
    method: "PATCH",
    url: `/instruments/categories/${id}/`,
    data,
  });
}

export function deleteCategory(id) {
  return http({
    method: "DELETE",
    url: `/instruments/categories/${id}/`,
  });
}

// model

export function createInstrumentsModel(data) {
  return http({
    method: "POST",
    url: "/instruments/types/",
    data,
  });
}

export function getInstrumentsModel(params) {
  return http({
    method: "GET",
    url: "/instruments/types/",
    params,
  });
}

export function updateCInstrumentModel({ data, id }) {
  return http({
    method: "PATCH",
    url: `/instruments/types/${id}/`,
    data,
  });
}

export function deleteInstruments(id) {
  return http({
    method: "DELETE",
    url: `/instruments/types/${id}/`,
  });
}

// model instrument variant

export function createInstrumentsModelVariant(data) {
  return http({
    method: "POST",
    url: "/instruments/instruments/",
    data,
  });
}

export function getInstrumentsModelVarian(params) {
  return http({
    method: "GET",
    url: "/instruments/instruments/",
    params,
  });
}

export function getInstrumentRemains(params) {
  return http({
    method: "GET",
    url: "/instruments/instruments/remains/",
    params: params,
  });
}

export function updateCInstrumentModelVarian(data) {
  return http.patch(`instruments/instruments/${data.get("id")}`, data);
}

export function deleteInstrumentsVarian(id) {
  return http({
    method: "DELETE",
    url: `/instruments/instruments/${id}/`,
  });
}

// vid material
export function createMaterialsTableId(data) {
  return http({
    method: "POST",
    url: "/product/goods/",
    data,
  });
}

export function getMaterialsTableId(params) {
  return http({
    method: "GET",
    url: "/product/goods/",
    params,
  });
}

export function getMaterialRemains(params) {
  return http({
    method: "GET",
    url: "/product/goods/remains",
    params,
  });
}

export function getMaterialRemainsExcel(params) {
  return http({
    method: "GET",
    url: "/product/goods/remains",
    params,
    responseType: "arraybuffer",
  });
}

export function getMaterialForBuilders(params) {
  return http({
    method: "GET",
    url: "/product/goods/remains_of_builders/",
    params,
  });
}
export function updateMaterialsVid({ data, id }) {
  return http({
    method: "PATCH",
    url: `/product/goods/${id}/`,
    data,
  });
}

export function deleteMaterialsVidId(id) {
  return http({
    method: "DELETE",
    url: `/product/goods/${id}/`,
  });
}
export function getModalDetails(id) {
  return http({
    method: "get",
    url: `/product/goods/${id}/storages_remains_by_good/`,
  });
}

// obects
export function createObects(data) {
  return http({
    method: "POST",
    url: "/storage/objects/",
    data,
  });
}

export function getObects(params) {
  return http({
    method: "GET",
    url: "/storage/objects/",
    params,
  });
}

export function updateObects({ data, id }) {
  return http({
    method: "PATCH",
    url: `/storage/objects/${id}/`,
    data,
  });
}

export function deleteObects(id) {
  return http({
    method: "DELETE",
    url: `/storage/objects/${id}/`,
  });
}

// Warehouse
export function createWarehouse(data) {
  return http({
    method: "POST",
    url: "/storage/storage/",
    data,
  });
}

export function getWarehouse(params) {
  return http({
    method: "GET",
    url: "/storage/storage/",
    params,
  });
}

export function getWarehouseId(params) {
  return http({
    method: "GET",
    url: "/storage/storage/",
    params,
  });
}

export function getWarehousePinModal(params) {
  return http({
    method: "GET",
    url: "/users/users/",
    params,
  });
}

// /users/users/

export function updateWarehouseChecked(data) {
  return http({
    method: "PATCH",
    url: `/storage/storage/${data.id}/`,
    data,
  });
}

export function updateWarehouse({ id, ...data }) {
  return http({
    method: "PATCH",
    url: `/storage/storage/${id}/`,
    data: { ...data },
  });
}

export function deletePinnedUser(id) {
  return http({
    method: "DELETE",
    url: `/storage/storage/${id}/`,
  });
}

// moneyReport
export function createMoneyReport(data) {
  return http({
    method: "POST",
    url: "/contract/investor/",
    data,
  });
}

export function getMoneyReport(params) {
  return http({
    method: "GET",
    url: "/contract/investor/",
    params,
  });
}

export function updateMoneyRepor({ data, id }) {
  return http({
    method: "PATCH",
    url: `/contract/investor/${id}/`,
    data,
  });
}

export function deleteMoneyRepor(id) {
  return http({
    method: "DELETE",
    url: `/contract/investor/${id}/`,
  });
}

export function getStatusMini() {
  return http({
    method: "GET",
    url: `/knowledge_base/statuses/status_mini/`,
  });
}

export function createWriteOffForInstrument(data) {
  return http({
    url: `/write_off/write_off_for_instrument/`,
    method: "POST",
    data: data,
  });
}

export function updateWriteOffForInstrument(data) {
  return http({
    url: `/write_off/write_off_for_instrument/${data.id}/`,
    method: "PATCH",
    data: data.data,
  });
}

export function getInstrumentModalDetails(id) {
  return http({
    method: "GET",
    url: `/instruments/instruments/${id}/storages_remains_by_instrument/`,
  });
}

export function getInstrumentRemainsBuilders(params) {
  return http({
    method: "GET",
    url: `/instruments/instruments/remains_of_builders/`,
    params,
  });
}

export function getBrigade(params) {
  return http({
    method: "GET",
    url: `/brigade/brigade/`,
    params,
  });
}
export function getOneBrigade(params) {
  return http({
    method: "GET",
    url: `/brigade/brigade/${params.id}`,
    params,
  });
}
export function createBrigade(data) {
  return http({
    url: `/brigade/brigade/`,
    method: "POST",
    data: data,
  });
}

export function updatePatchBrigade(data) {
  console.log(data);
  return http({
    url: `/brigade/brigade/${data.id}/`,
    method: "PATCH",
    data: data,
  });
}

export function updatePutBrigade(data) {
  return http({
    url: `/brigade/brigade/${data.id}/`,
    method: "PUT",
    data: data,
  });
}

export function deleteBrigade(payload) {
  return http({
    method: "DELETE",
    url: `/brigade/brigade/${payload}`,
  });
}

export function getAllBrigadeWorkCategories(params) {
  return http({
    method: "GET",
    url: `/brigade/work-type-category/`,
    params,
  });
}

export function getOneBrigadeWorkCategories(params) {
  return http({
    method: "GET",
    url: `/brigade/work-type-category/${params.id}/`,
  });
}
export function createBrigadeWorkCategories(data) {
  return http({
    url: `/brigade/work-type-category/`,
    method: "POST",
    data: data,
  });
}

export function updatePatchBrigadeWorkCategories(data) {
  return http({
    url: `/brigade/work-type-category/${data.id}/`,
    method: "PATCH",
    data: data.data,
  });
}

export function updatePutBrigadeWorkCategories(data) {
  return http({
    url: `/brigade/work-type-category/${data.id}/`,
    method: "PUT",
    data: data,
  });
}

export function deleteWorkCategories(payload) {
  return http({
    method: "DELETE",
    url: `/brigade/work-type-category/${payload}`,
  });
}

export function deleteBrigadeWorkCategories(payload) {
  return http({
    method: "DELETE",
    url: `/brigade/work-type-category/${payload}/`,
  });
}

export function getAllBrigadeWorks(params) {
  return http({
    method: "GET",
    url: `/brigade/work-type/`,
    params,
  });
}

export function getOneBrigadeWorks(params) {
  return http({
    method: "GET",
    url: `/brigade/work-type/${params.id}/`,
  });
}
export function createBrigadeWorks(data) {
  return http({
    url: `/brigade/work-type/`,
    method: "POST",
    data: data,
  });
}

export function updatePatchBrigadeWorks(data) {
  return http({
    url: `/brigade/work-type/${data.id}/`,
    method: "PATCH",
    data: data.data,
  });
}

export function updatePutBrigadeWorks(data) {
  return http({
    url: `/brigade/work-type/${data.id}/`,
    method: "PUT",
    data: data,
  });
}

export function deleteWorks(payload) {
  return http({
    method: "DELETE",
    url: `/brigade​/work-type​/${payload}`,
  });
}

export function deleteBrigadeWorks(payload) {
  return http({
    method: "DELETE",
    url: `/brigade/work-type/${payload}/`,
  });
}

export function getTransport(params) {
  return http({
    method: "GET",
    url: `/transports/transport/`,
    params,
  });
}

export function getOneTransport(params) {
  return http({
    method: "GET",
    url: `/transports/transport/${data.id}/`,
    params,
  });
}

export function createTransport(data) {
  return http({
    url: `/transports/transport/`,
    method: "POST",
    data: data,
  });
}

export function updatePatchTransport(data) {
  return http({
    url: `/transports/transport/${data.id}/`,
    method: "PATCH",
    data: data.data,
  });
}

export function updatePutTransport(data) {
  return http({
    url: `/transports/transport/${data.id}/`,
    method: "PUT",
    data: data.data,
  });
}

export function deleteTransport(payload) {
  return http({
    method: "DELETE",
    url: `/transports/transport/${payload}`,
  });
}

export function getTransportCategory(params) {
  return http({
    method: "GET",
    url: `/transports/transport_category/`,
    params,
  });
}

export function getOneTransportCategory(params) {
  return http({
    method: "GET",
    url: `/transports/transport_category/${data.id}/`,
    params,
  });
}

export function createTransportCategory(data) {
  return http({
    url: `/transports/transport_category/`,
    method: "POST",
    data: data,
  });
}

export function updatePatchTransportCategory(data) {
  return http({
    url: `/transports/transport_category/${data.id}/`,
    method: "PATCH",
    data: data.data,
  });
}

export function updatePutTransportCategory(data) {
  return http({
    url: `/transports/transport_category/${data.id}/`,
    method: "PUT",
    data: data,
  });
}

export function deleteTransportCategory(payload) {
  return http({
    method: "DELETE",
    url: `/transports/transport_category/${payload}`,
  });
}

export function getPlaceOfWork(params) {
  return http({
    method: "GET",
    url: `/brigade/work-place/`,
    params,
  });
}

// export function getOneTransportCategory(params) {
//   return http({
//     method: 'GET',
//     url: `/transports/transport_category/${data.id}/`,
//     params
//   })
// }

export function createPlaceOfWork(data) {
  return http({
    url: `/brigade/work-place/`,
    method: "POST",
    data: data,
  });
}

export function updatePatchPlaceOfWork(data) {
  return http({
    url: `/brigade/work-place/${data.id}/`,
    method: "PATCH",
    data: data.data,
  });
}

export function updatePutPlaceOfWork(data) {
  return http({
    url: `/brigade/work-place/${data.id}/`,
    method: "PUT",
    data: data,
  });
}

export function deletePlaceOfWork(payload) {
  return http({
    method: "DELETE",
    url: `/brigade/work-place/${payload}`,
  });
}

export function exportExcelMaterialTypes(params) {
  return http({
    url: `/product/export_exal_types_of_materials/`,
    method: "GET",
    params,
    responseType: "blob",
  });
}

export function exportExcelMaterial(params) {
  return http({
    url: `/product/export_exal_types_of_good/`,
    method: "GET",
    params,
    responseType: "blob",
  });
}

export function exportExcelInstruments(params) {
  return http({
    url: `/product/export_exel_instruments_instruments/`,
    method: "GET",
    params,
    responseType: "blob",
  });
}

export function exportExcelInstrumentTypes(params) {
  return http({
    url: `/product/export_exel_instruments_types/`,
    method: "GET",
    params,
    responseType: "blob",
  });
}
